import styled from '@emotion/styled';

import * as color from '@constant/color';
import * as size from '@constant/size';
import * as animation from '@constant/animation';
import React from 'react';
import IconBlock from '@component/common/block/icon-block';
import { useNavigate } from 'react-router-dom';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as authActions } from '@store/slice/auth-slice';
import { IS_IYAGIGO_MOBILE_VIEW, SERVICE } from '@config/environment';
import { EService } from '@datatype/type';

interface IProps {
  children?: React.ReactNode;
  design?: {
    width?: string; // e.g: 10px
    height?: string; // e.g: 10px
  };
  onCloseClick?: any;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: ${SERVICE === EService.GRIDGIO || IS_IYAGIGO_MOBILE_VIEW ? '0' : size.WEB_SIDE_WIDTH};
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.3);

  ${animation.MODAL_BACKGROUND_FADE_IN_CSS}
`;

const Form = styled.div<Pick<IProps, 'design'>>`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;

  position: relative;
  padding: ${size.MARGIN_4} ${size.MARGIN_3} ${size.MARGIN_3} ${size.MARGIN_3};
  background-color: ${color.WHITE_1};
  border-radius: ${size.BORDER_RADIUS_3};
  width: ${(props) => props.design?.width || 'auto'};
  height: ${(props) => props.design?.height || 'auto'};

  ${animation.MODAL_FADE_IN_CSS}
`;

const CloseButtonContainer = styled.div`
  position: absolute;
  top: ${size.MARGIN_1};
  right: ${size.MARGIN_1};
`;

const AuthBox: React.FC<IProps> = ({ children, design, onCloseClick }) => {
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  const handleCloseButtonClick = () => {
    // navigate('/');
  };
  const handleCloseClick = () => {
    if (onCloseClick) {
      onCloseClick();
    } else {
      dispatch(authActions.initialize());
    }
  };

  const handleClickModal = (ev) => {
    if (ev.currentTarget !== ev.target) return;
    dispatch(authActions.initialize());
  };

  return (
    <Wrapper onClick={handleClickModal}>
      <Form design={design}>
        <CloseButtonContainer onClick={handleCloseButtonClick}>
          <IconBlock
            icon='close'
            design={{
              icon: { size: 'medium', kind: 'outlined' },
              box: { event: { cursor: 'pointer' } },
            }}
            click={{ handler: handleCloseClick }}
          />
        </CloseButtonContainer>
        {children}
      </Form>
    </Wrapper>
  );
};

export default AuthBox;
